import React from "react";

function Paginate(props) {
  const meta = props.meta || {};
  const count = [];
  for (var i = 1; i <= (meta.last_page || 0); i++) {
    count.push(i);
  }

  const changePage = (pageNumber) => {
    props.changePage(pageNumber);
  };

  const handleback = (number) => {
    props.handleSetPage(number);
  };

  if (!meta.last_page || meta.last_page <= 1) {
    return null;
  }

  return (
    <div className="w-100">
      <div className="col-12 d-flex justify-content-center">
        <nav aria-label="Page navigation">
          <ul className="pagination">
            {props.page <= 1 ? null : (
              <li className="page-item">
                <button
                  type="button"
                  className="page-link"
                  onClick={() => handleback(-1)}
                >
                  Trước
                </button>
              </li>
            )}
            {count.map((pageNumber) => {
              if (
                pageNumber === 1 ||
                pageNumber === count.length ||
                (pageNumber >= props.page - 2 && pageNumber <= props.page + 2)
              ) {
                return (
                  <li
                    className={`page-item ${props.page === pageNumber ? "active" : ""}`}
                    key={pageNumber}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => changePage(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              } else if (
                (pageNumber === props.page - 3 ||
                  pageNumber === props.page + 3) &&
                pageNumber > 1 &&
                pageNumber < count.length
              ) {
                return (
                  <li className="page-item disabled" key={pageNumber}>
                    <span className="page-link">...</span>
                  </li>
                );
              }
              return null;
            })}
            {props.page >= meta.last_page ? null : (
              <li className="page-item">
                <button
                  type="button"
                  className="page-link"
                  onClick={() => handleback(1)}
                >
                  Sau
                </button>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Paginate;
